import { render, staticRenderFns } from "./WomensDay.vue?vue&type=template&id=6530c8f7&scoped=true"
import script from "./WomensDay.vue?vue&type=script&lang=js"
export * from "./WomensDay.vue?vue&type=script&lang=js"
import style0 from "./WomensDay.vue?vue&type=style&index=0&id=6530c8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530c8f7",
  null
  
)

export default component.exports